import apiService from '../api.service';

class PackRepository {
  async getAll() {
    const response = await apiService.get('/packs');
    console.log('PackRepository.getAll response:', response);
    // API returns array directly, not wrapped in data
    return Array.isArray(response) ? response : (response.data || response);
  }

  async getById(id) {
    const response = await apiService.get(`/packs/${id}`);
    return response.data || response;
  }

  async create(data) {
    const response = await apiService.post('/packs', data);
    return response.data;
  }

  async update(id, data) {
    const response = await apiService.post(`/packs/${id}/update`, data);
    return response.data;
  }

  async delete(id) {
    const response = await apiService.delete(`/packs/${id}`);
    return response.data;
  }

  async getProductsForPack() {
    const response = await apiService.get('/packs/create');
    return response.data;
  }

  async getPackWithProducts(id) {
    const response = await apiService.get(`/packs/${id}`);
    return response.data;
  }
}

const packRepository = new PackRepository();
export default packRepository;